<template>
  <v-container fluid style="margin-top: 2%">
    <v-layout wrap row>
      <v-flex lg6 md6 v-if="singleProgram.images.length > 0">
        <v-container fluid>
          <v-flex lg6 md6>
            <img
              :src="singleProgram.image"
              alt=""
              width="80%"
              class="img-rounded"
            />
          </v-flex>
          <br />
          <br />
          <h3
            class="text-center earth-color"
            style="text-decoration: underline"
          >
            {{ singleProgram.name.toUpperCase() }}
          </h3>
        </v-container>
      </v-flex>
      <v-flex lg12 md12 v-if="singleProgram.images.length <= 0">
        <v-container fluid>
          <v-flex lg8 md8>
            <img
              :src="singleProgram.image"
              alt=""
              width="80%"
              height="40%"
              class="img-rounded"
            />
          </v-flex>
          <br />
          <br />
          <h3
            class="text-center earth-color"
            style="text-decoration: underline"
          >
            {{ singleProgram.name.toUpperCase() }}
          </h3>
        </v-container>
      </v-flex>
      <v-flex lg6 md6>
        <v-container fluid>
          <div class="row">
            <div
              class="col-md-4"
              v-for="(image, key) in singleProgram.images"
              :key="key"
            >
              <img :src="image.image" alt="" width="100%" class="img-rounded" />
            </div>
          </div>
        </v-container>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex lg5 md5 sm12 xs12 v-if="singleProgram.program_pdf !== null">
        <v-container fluid>
          <v-card flat>
            <v-container fluid>
              <v-layout row wrap hidden-md-and-down>
                <v-flex lg4 md4 sm4 xs4> </v-flex>
                <v-flex lg4 md4 sm4 xs4>
                  <v-btn
                    :depressed="true"
                    color="primary"
                    small
                    @click="page = page += -1"
                    fab
                    round
                    v-if="currentPage >= 2"
                    ><v-icon>navigate_before</v-icon></v-btn
                  >
                  <v-chip class="text-md-center text-lg-center text-sm-center"
                    >{{ currentPage }} / {{ pageCount }}</v-chip
                  >
                  <v-btn
                    :depressed="true"
                    color="primary"
                    small
                    @click="page = page + 1"
                    fab
                    round
                    v-if="currentPage < pageCount"
                    ><v-icon>navigate_next</v-icon></v-btn
                  >
                </v-flex>
                <v-flex lg4 md4 sm4 xs4> </v-flex>
              </v-layout>
              <pdf
                :src="pdf_data"
                @num-pages="pageCount = $event"
                @page-loaded="currentPage = $event"
                :page="page"
              ></pdf>
              <v-layout row wrap>
                <v-flex lg4 md4 sm12 xs4> </v-flex>
                <v-flex lg4 md4 sm4 xs4>
                  <v-btn
                    :depressed="true"
                    color="primary"
                    small
                    @click="page = page += -1"
                    fab
                    round
                    v-if="currentPage >= 2"
                    ><v-icon>navigate_before</v-icon></v-btn
                  >
                  <v-chip class="text-center"
                    >{{ currentPage }} / {{ pageCount }}</v-chip
                  >
                  <v-btn
                    :depressed="true"
                    fab
                    round
                    color="primary"
                    small
                    @click="page = page + 1"
                    v-if="currentPage < pageCount"
                    ><v-icon>navigate_next</v-icon></v-btn
                  >
                </v-flex>
                <v-flex lg4 md4 sm4 xs4> </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex lg12 md12 sm12 xs12>
                  <v-btn
                    :depressed="true"
                    :href="singleProgram.program_pdf"
                    target="_blank"
                    color="secondary"
                    small
                    class="blink"
                    block
                    ><v-icon>save_alt</v-icon></v-btn
                  >
                </v-flex>
              </v-layout>
              <br />
            </v-container>
          </v-card>
        </v-container>
      </v-flex>
      <v-flex lg6 md6 sm12 xs12 v-else>
        <v-container fluid>
          <v-card flat>
            <v-container>
              <span v-html="singleProgram.desc"></span>
            </v-container>
          </v-card>
        </v-container>
      </v-flex>
      <v-flex lg6 md6 sm12 xs12>
        <v-container fluid>
          <v-card flat>
            <br />
            <v-container fluid>
					<br>
							<br>
							<h3 class="knockout-color">TO APPLY FOR PROGRAM PLEASE CONTACT US VIA :</h3> 
							<br>
							<strong class="knockout-color" >EMAIL:<a class="knockout-color" :href="'mailto:' + email">{{email}}</a></strong> 
							<br>
							<br>
							<h3 class="knockout-color" >Call us on : 254 (0) 707 187 141</h3> 
             
            </v-container>
          </v-card>
        </v-container>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import pdf from "vue-pdf";
export default {
  name: "program",
  components: {
    Datepicker,
    pdf,
  },
  data() {
    return {
      max_date: this.$moment().subtract(13, "years").format("YYYY-MM-DD"),
      requiredRules: [(v) => !!v || "This field is required"],
      email: "reservations@olpejetaconservancy.org",
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],
      valid: true,
      menu1: false,
      modal1: false,
      menu2: false,
      modal2: false,
      menu3: false,
      modal3: false,
      currentPage: 0,
      pageCount: 0,
      page: 1,
      numPages: undefined,
      program: {
        program_id: this.$route.params.program_id,
        first_name: "",
        sur_name: "",
        email: "",
        tel: "",
        dob: "",
        code: "",
        id_alien_number: "",
        postal_address: "",
        postal_code: "",
        title: "",
        gender: "",
        place_of_issue: "",
        date_of_issue: "",
        expiry_date: "",
        dietary: "",
      },
      index: null,
    };
  },
  mounted() {
    this.pdf_data.then((pdf) => {
      this.numPages = pdf.numPages;
    });
  },
  computed: {
    pdf_data() {
      return pdf.createLoadingTask(this.singleProgram.program_pdf);
    },
    disabled_settings: function () {
      return {
        from: new Date(
          this.$moment().subtract(13, "years").format("YYYY, MM, DD")
        ),
      };
    },
    allImages: function () {
      var imgObjects = this.singleProgram.images;
      var images = [];
      for (var i = 0; i < imgObjects.length; i++) {
        images.push({ src: imgObjects[i].image, thumb: imgObjects[i].image });
      }
      return images;
    },
  },
  created() {
    // context.commit('GET_PROGRAM', {[]})
    this.$store.dispatch("get_program", this.$route.params.program_id);
    this.$store.dispatch("get_all_genders");
    this.$store.dispatch("get_all_countries");
  },
  methods: {
    findCountryCode(data) {
      var instance = this;
      this.allCountries.map(function (country) {
        if (data === country.code) {
          instance.program.tel = "+" + country.calling_code;
        }
      });
    },
    formatDob: function () {
      this.program.dob = this.$moment(this.program.dob).format("YYYY-MM-DD");
    },
    volunteerNow: function () {
      // this.program.code = this.program.code.public_id
      if (this.$refs.form.validate()) {
        this.program.dob = this.$moment(this.program.dob).format("YYYY-MM-DD");
        this.$store.dispatch("post_volunteer", this.program);
      }
    },
    showImages: function () {
      this.x = true;
      console.log(this.x);
    },
  },
};
</script>

<style scoped>
@-webkit-keyframes blink {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
.blink {
  -webkit-animation-name: blink;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-timing-function: cubic-bezier(1, 0, 0, 1);
  -webkit-animation-duration: 2s;
}
</style>
